import { get } from '~/utils/ajax';
import { settings } from '~/utils/settings';

type CouponStateType = {
    coupons: ICoupon[];
};
export async function syncContentState(): Promise<CouponStateType> {
    return await get(settings.urls.contentStateSyncUrl);
}
